import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import firebase from 'firebase/app';
import 'firebase/auth';
import { setNavIsOpen } from '../../../redux/Redux.actions';
import clsx from 'clsx';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import Typography from '@material-ui/core/Typography';
import CssBaseline from '@material-ui/core/CssBaseline';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/styles';
import { Messages } from "../../_locale/locale.en";

import { styles } from '../Layout.styles.js';
import { theme } from '../Layout.theme';

const mapStateToProps = state => ({
  isNavDrawerOpen: state.views.isNavDrawerOpen,
});

const mapDispatchToProps = dispatch => ({
  setNavIsOpen: val => dispatch(setNavIsOpen(val)),
});

class Header extends Component {
  render () {
    const { isNavDrawerOpen, classes, history } = this.props;
    return (
      <React.Fragment>
        <CssBaseline />
        <AppBar
          position="fixed"
          className={clsx(classes.appBar, {
            [classes.appBarShift]: isNavDrawerOpen,
          })}
        >
          <Toolbar>
            <IconButton
              color="inherit"
              aria-label="Open drawer"
              onClick={() => this.props.setNavIsOpen(true)}
              edge="start"
              className={clsx(classes.menuButton, {
                [classes.hide]: isNavDrawerOpen,
              })}
            >
              <MenuIcon />
            </IconButton>
            <Typography className={classes.title} variant="h6" noWrap>{Messages.Header.Title}</Typography>
            <Button
              // variant="contained"
              color="primary"
              className={clsx([classes.button, classes.logoutButton])}
              onClick={() => { firebase.auth().signOut().then(() => history.push('/') ) }}>
                <Link className={classes.logoutLink} to="/">{Messages.Header.Buttons.LogOut}</Link>
            </Button>
          </Toolbar>
        </AppBar>
      </React.Fragment>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(
  withStyles(
    styles,
    {
      defaultTheme: theme,
      withTheme: true,
      name: 'layout',
    }
  )(withRouter(Header)));
